import * as React from 'react';

import Megaphone20 from './Megaphone20';

export const megaphone20 = () => <Megaphone20 />;

export default {
    title: 'Icon|Fill|Megaphone20',
    component: Megaphone20,
    parameters: {
        notes: "`import Megaphone20 from 'box-ui-elements/es/icon/fill/Megaphone20';`",
    },
};
